import { render, staticRenderFns } from "./question-group-select.vue?vue&type=template&id=4fd15f24&scoped=true"
import script from "./question-group-select.vue?vue&type=script&lang=ts"
export * from "./question-group-select.vue?vue&type=script&lang=ts"
import style0 from "./question-group-select.vue?vue&type=style&index=0&id=4fd15f24&prod&lang=scss"
import style1 from "./question-group-select.vue?vue&type=style&index=1&id=4fd15f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd15f24",
  null
  
)

export default component.exports